import type { TeamCreationFormValues } from '@bb/components/Onboarding/steps';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { clients } from '../clients';
import { QueryKey } from '../hooks/QueryKey';
import { useUserProfile } from '../hooks/useUserProfile';

export function useCreateTeamMutation() {
  const { userProfile } = useUserProfile();
  const queryClient = useQueryClient();

  const {
    mutateAsync: createTeam,
    isLoading: createTeamLoading,
    error: createTeamError,
  } = useMutation({
    mutationFn: async (data: TeamCreationFormValues) => {
      return await clients.team.create({
        payload: {
          ...data,
        },
      });
    },
    onSuccess: async (data) => {
      await queryClient.invalidateQueries([QueryKey.Team]);
      toast.success('Your team creation request has been sent!');
    },
  });

  return {
    createTeam,
    createTeamLoading,
    createTeamError,
  };
}
